<script>
    import { createEventDispatcher } from "svelte";

    export let value = "";
    export let placeholder = "";
    export let hasLabel = true;
    const dispatch = createEventDispatcher();

    let timer;

    function debounceInput (event) {
        clearTimeout(timer);

        timer = setTimeout(() => {
            value = event.target.value;
            dispatch("search", value)
        }, 400);
    }

</script>

<div class="w-full">
    {#if hasLabel}
        <div class="text-gray-500">
            Filtra per
        </div>
    {/if}

    <input
        type="text"
        name="name"
        bind:value
        on:input={(value) => debounceInput(value)}
        placeholder={placeholder}
        class="h-11 w-full border-gray-300"
    >
</div>